import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '212631387567';

export const getWhatsAppHref = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

const VARIANTS = {
  solid: 'bg-[#25D366] text-white hover:bg-[#20bd5a] shadow-lg shadow-green-900/10 hover:scale-105',
  outline: 'border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10',
  link: 'text-slate-500 hover:text-[#25D366]',
};

export function WhatsAppButton({ className = '', variant = 'solid', message, iconOnly = false, children }) {
  const sizing = iconOnly ? 'p-2.5' : variant === 'link' ? 'gap-2' : 'gap-2 px-6 py-3';
  return (
    <a
      href={getWhatsAppHref(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter M'EyeBus sur WhatsApp"
      className={`inline-flex items-center justify-center rounded-xl font-bold transition-all ${sizing} ${VARIANTS[variant]} ${className}`}
    >
      <MessageCircle className="h-5 w-5 shrink-0" />
      {!iconOnly && children}
    </a>
  );
}
